<template>
  <div class="tagsview">
    <div class="tagsview-container">
        <!-- <i class="el-icon-caret-left" :class="{'disabled':disabledLeft}" @click="scrollTo()"></i> -->
        <div class="tagsview-wrapper" :style="{height: domHeight + 'px'}">
            <div :style="{'width':width}">
                <router-link
                    v-for="(tag,tagIndex) in visitedViews"
                    ref="tag"
                    :class="isActive(tag)?'active':''"
                    :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
                    :key="tagIndex"
                    tag="span"
                    class="tagsview-item">
                    <!-- @contextmenu.prevent.native="openMenu(tag,$event)" -->
                    <!--   @click.middle.native="closeSelectedTag(tag)" -->
                    <!-- {{tag.title}} -->
                    <span  @click.prevent.stop="beforeEach(tag)"> {{tag.title}}</span>
                    <span class="el-icon-close" v-show="tagIndex!==0" @click.prevent.stop="closeSelectedTag(tag)" />
                </router-link>
            </div>
        </div>
        <i class="el-icon-arrow-right" @click="scrollTo(1)" v-show="visitedViews.length > 1"></i>
        <div class="tags-dropdown" v-show="visitedViews.length > 1">
            <el-dropdown>
                <span class="el-dropdown-link">
                    <i class="el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="closeSelectedTag(selectedTag)" 
                        :disabled="selectedTag.name == 'home' ? true : false">关闭当前标签
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="closeOthersTags">关闭其它标签</el-dropdown-item>
                    <el-dropdown-item @click.native="closeAllTags">关闭全部标签</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
    <!-- <div @click="closeAllTags" class="tags-closeAll">关闭全部</div> -->
    <!-- <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
        <li @click="refreshSelectedTag(selectedTag)"> 刷新</li>
        <li @click="closeSelectedTag(selectedTag)">关闭</li>
        <li @click="closeOthersTags">关闭其他</li>
        <li @click="closeAllTags">关闭所有</li>
    </ul> -->
  </div>
</template>

<script>
import {mapState} from 'vuex';

import './comps.less'

let menuObj = {}
export default {
//   components: { ScrollPane },
    data() {
            return {
            visible: false,
            top: 0,
            left: 0,
            domHeight: 32,
            selectedTag: {},
            width:"auto",
            disabledLeft:true,
            disabledRight:true,
        }
    },
    computed: {
         ...mapState({
            visitedViews: function(state){
                return state.tagsView.visitedViews
            },
        })
    },
    watch: {
        $route() {
            this.addViewTags()
            this.moveToCurrentTag()
        },
        visible(value) {
            if (value) {
                document.body.addEventListener('click', this.closeMenu)
            } else {
                document.body.removeEventListener('click', this.closeMenu)
            }
        }
    },
    created() {
        const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        if (userAgent.indexOf("Firefox") > -1) { //判断是否Firefox浏览器
            this.domHeight = 45
        }
        this.onDealMenuTreeData()
    },  
    mounted() {
        let me = this
        let tags = this.$store.state.tagsView.visitedViews
        if (tags && tags.length) {
            this.$store.dispatch('setVisitedView', tags||[])
        }else{
            this.selectedTag = this.onGetNewRoute()
            this.addViewTags()
        }
        this.updateWidth()
        this.$bus.on("deleteTagsVIew",function(val){
            if(val&&val.length){
                val.forEach(v => {
                    me.$store.dispatch('delView', v).then(({ visitedViews }) => {})
                });
            }
        })
    },
    beforeDestroy(){
        this.$bus.off("deleteTagsVIew")
    },
    methods: {
        /**
         * @description: 将菜单树数据展开成对象，方便后面使用
         */        
        onDealMenuTreeData(){
            const navs = $storage.getItem("navs", 1)
            this.onTransformTreeToObj(navs['childList'])
            window.$menuObj = menuObj
        },
        onTransformTreeToObj(datas){
            for (const menu of datas) {
                menuObj[menu.keyName] = menu.name
                if(menu.childList && menu.childList.length){
                    this.onTransformTreeToObj(menu['childList'])
                }
            }
        },
        /**
         * @description: 一级菜单获取数据库字段值
         */        
        onGetNewRoute(){
            let { name , path, meta } = this.$route
            // 没有二级副标题的处理 
            if(meta && meta['title'] && menuObj[name]){
                meta['title'] = menuObj[name]
            }

            // 有二级副标题
            const pathArr = path.split('/')
            if(pathArr.length == 3){
                if(meta && meta['subtitle'] && menuObj[pathArr[1]]){
                    meta['title'] = menuObj[pathArr[1]] + '-' + meta['subtitle']
                }
            }
            return { name , path, meta}
        },
        updateWidth(){
             let me = this
            this.$nextTick(()=>{
                let width = 0
                let tagsItem = document.querySelectorAll(".tagsview-item")
                let tagswrapper = document.querySelector(".tagsview-wrapper")
                for (let tag =0; tag< tagsItem.length;tag++){
                    width+= tagsItem[tag].offsetWidth
                    
                }
                if(width){
                    width += 166;
                }
                if(!tagswrapper.scrollLeft){
                    me.disabledLeft=true;
                }else{
                    me.disabledLeft=false;
                }
                if((tagswrapper.clientWidth+tagswrapper.scrollLeft + 15) >= width){
                    me.disabledRight=true;
                }else{
                    me.disabledRight=false;
                }
                if(tagswrapper.clientWidth < width){
                    me.width = width + 'px'
                }else{
                    me.width = 'auto'
                }
               
                setTimeout(() => {
                    this.moveToCurrentTag()
                }, 0);
            })
        },
        isActive(route) {
            return route.path === this.$route.path
        },
        addViewTags() {
            const { name } = this.$route
            if (name  && name != 'middlePage') {
                this.selectedTag = this.onGetNewRoute()
                this.$store.dispatch('addView', this.selectedTag)
                this.$forceUpdate()
            }
            this.updateWidth()
            return false
        },
        moveToCurrentTag() {
            const tags = this.$refs.tag
            if(!tags) return
            this.$nextTick(() => {
                for (const tag of tags) {
                    if (tag.to.path === this.$route.path) {
                        // when query is different then update
                        if (tag.to.fullPath !== this.$route.fullPath) {
                            this.$store.dispatch('updateVisitedView', this.onGetNewRoute())
                        }
                        break
                    }
                }
            })
        },
        refreshSelectedTag(view) {
            this.$store.dispatch('delCachedView', view).then(() => {
                const { fullPath } = view
                this.$nextTick(() => {
                    this.$router.replace({
                        path: '/redirect' + fullPath
                    })
                })
            })
        },
        closeSelectedTag(view,type) {
            // let me = this
            // if(["/addvoucher"].indexOf(view.path)>-1&&!type){
            //     this.$bus.$emit("onCloseSelectedTag",view,function(){
            //         me.closeSelectedTag(view,1)
            //     })
            //     return
            // }

            // 首页不删除
            if(view.name == 'home') return
            if (this.isActive(view)) {
                this.updateNavMenu()
            }
            this.$store.commit('UPDATE_ISPASS',true)
            this.$store.dispatch('delView', view).then(({ visitedViews }) => {
                if (this.isActive(view)) {
                    const latestView = visitedViews.slice(-1)[0]
                    if (latestView) {
                        this.$router.push(latestView)
                    } else {
                        this.$router.push('/')
                    }
                }
            })
        },
        closeOthersTags() {
            this.updateNavMenu()
            this.$router.push(this.selectedTag)
            this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
                this.moveToCurrentTag()
            })
        },
        closeAllTags() {
            this.$store.dispatch('delAllViews')
            this.updateNavMenu()
            this.$router.push('/home')
        },
        openMenu(tag, e) {
            const menuMinWidth = 105
            const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
            const offsetWidth = this.$el.offsetWidth // container width
            const maxLeft = offsetWidth - menuMinWidth // left boundary
            const left = e.clientX - offsetLeft + 15 // 15: margin right

            if (left > maxLeft) {
                this.left = maxLeft
            } else {
                this.left = left
            }
            this.top = e.clientY

            this.visible = true
            this.selectedTag = tag
        },
        closeMenu() {
            this.visible = false
        },
        scrollTo(type,isdisable){
            let wrapper = document.querySelector(".tagsview-wrapper")
            let scrollLeft = wrapper.scrollLeft
            let scrollWidth = wrapper.scrollWidth
            let clientWidth = wrapper.clientWidth
            if(type){
                let tpmWith = scrollLeft + clientWidth
                if(tpmWith<scrollWidth){
                    wrapper.scrollLeft=tpmWith
                }
            }else{
                let tpmWith = scrollLeft - clientWidth
                if(tpmWith>0){
                    wrapper.scrollLeft=tpmWith
                }else{
                    wrapper.scrollLeft=0;
                }

            }
            let width = this.width.replace("auto",'').replace("px",'')
            if(!wrapper.scrollLeft){
                this.disabledLeft=true;
            }else{
                this.disabledLeft=false;
            }
            if((wrapper.clientWidth+wrapper.scrollLeft+15)>=Number(width||0) ){
                this.disabledRight=true;
            }else{
                this.disabledRight=false;
            }
        },
        beforeEach(view){
            let that = this;
            // if(["/agentList/editAgent","/customerList/editCustomer"].indexOf(this.$route.path)>-1){
            //     alert('当前页面属于编辑页面，请点击 X 关闭或者点击【返回】按钮')
            //     return
            // }
            this.updateNavMenu()
            let routeQuery = $storage.getItem("routeQuery");
            if(["/agentList/editAgent","/customerList/editCustomer"].indexOf(view.path)>-1 && routeQuery){
                this.$router.push({
                    path:view.path,
                    query:routeQuery
                })
                return
            }

            this.$router.push(view.path)
            this.selectedTag = view
        },
        updateNavMenu(){
            this.$bus.emit('updateNavMenu')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/comps/tagsView.vue